// Content block shown under every sold listing on the VDP: a "Most popular vehicles"
// paragraph and the "Guides for selling your used vehicle" link hub (50 state guides).
// Moved out of Strapi (base-page /listing-details-sold, link hub #1) as part of retiring
// Strapi (PA-3464); editing it is now a code change (decision recorded on PA-6668).
// Shape matches the Strapi `Content` array that ContentBlock and LinkHub render, trimmed
// to the fields they read for this element type and link-hub style.
export const LISTING_DETAILS_SOLD_CONTENT = [
  {
    id: 871,
    __component: "page-elements.image-text",
    Title: "Most popular vehicles",
    Position: "Left",
    Content:
      "Here are some of our best selling cars. [Browse our full inventory of used vehicles for sale!](https://privateauto.com/buy)\n\n- [Ford Bronco](https://privateauto.com/buy/ford-for-sale/bronco)\n- [Toyota Tacoma](https://privateauto.com/buy/toyota-for-sale/tacoma)\n- [Dodge Charger](https://privateauto.com/buy/dodge-for-sale/charger)\n- [Jeep Wrangler](https://privateauto.com/buy/jeep-for-sale/wrangler)",
    Color: "White",
    Width: "w Full",
    TitleStyle: "H2",
    SubTitle: null,
    SubTitleStyle: "H1",
    Buttons: "None",
    TextStyle: "Normal",
    TextAlignment: "Left",
    TitleAlignment: "Left",
    VideoURL: null,
    BackgroundStyle: "Full",
    Background: null,
    BackgroundLower: null,
    ImageHeight: null,
    ImageWidth: null,
    WrapText: null,
    BackgroundImage: {
      data: null,
    },
    CTAs: {
      data: [],
    },
    Image: {
      data: null,
    },
    Video: {
      data: null,
    },
    Overrides: {
      data: [],
    },
  },
  {
    id: 20,
    __component: "page-elements.link-hub",
    Title: "Guides for selling your used vehicle",
    TitleStyle: "H2",
    Style: "Link",
    Display: 1,
    Design: null,
    LinkHub: {
      data: {
        attributes: {
          Name: "How to Sell My Used Car in Each State?",
          Pages: [
            {
              id: 1,
              __component: "linkhub.sell-link",
              Title: "Alabama",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-alabama",
                  },
                },
              },
            },
            {
              id: 2,
              __component: "linkhub.sell-link",
              Title: "Alaska",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-alaska",
                  },
                },
              },
            },
            {
              id: 4,
              __component: "linkhub.sell-link",
              Title: "Arizona",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-arizona",
                  },
                },
              },
            },
            {
              id: 3,
              __component: "linkhub.sell-link",
              Title: "Arkansas",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-arkansas",
                  },
                },
              },
            },
            {
              id: 5,
              __component: "linkhub.sell-link",
              Title: "California",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-california",
                  },
                },
              },
            },
            {
              id: 6,
              __component: "linkhub.sell-link",
              Title: "Colorado",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-colorado",
                  },
                },
              },
            },
            {
              id: 7,
              __component: "linkhub.sell-link",
              Title: "Connecticut",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-connecticut",
                  },
                },
              },
            },
            {
              id: 8,
              __component: "linkhub.sell-link",
              Title: "Delaware",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-delaware",
                  },
                },
              },
            },
            {
              id: 9,
              __component: "linkhub.sell-link",
              Title: "Florida",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-florida",
                  },
                },
              },
            },
            {
              id: 10,
              __component: "linkhub.sell-link",
              Title: "Georgia",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-georgia",
                  },
                },
              },
            },
            {
              id: 11,
              __component: "linkhub.sell-link",
              Title: "Hawaii",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-hawaii",
                  },
                },
              },
            },
            {
              id: 12,
              __component: "linkhub.sell-link",
              Title: "Idaho",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-idaho",
                  },
                },
              },
            },
            {
              id: 13,
              __component: "linkhub.sell-link",
              Title: "Illinois",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-illinois",
                  },
                },
              },
            },
            {
              id: 14,
              __component: "linkhub.sell-link",
              Title: "Indiana",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-indiana",
                  },
                },
              },
            },
            {
              id: 15,
              __component: "linkhub.sell-link",
              Title: "Iowa",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-iowa",
                  },
                },
              },
            },
            {
              id: 16,
              __component: "linkhub.sell-link",
              Title: "Kansas",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-kansas",
                  },
                },
              },
            },
            {
              id: 17,
              __component: "linkhub.sell-link",
              Title: "Kentucky",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-kentucky",
                  },
                },
              },
            },
            {
              id: 18,
              __component: "linkhub.sell-link",
              Title: "Louisiana",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-louisiana",
                  },
                },
              },
            },
            {
              id: 19,
              __component: "linkhub.sell-link",
              Title: "Maine",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-maine",
                  },
                },
              },
            },
            {
              id: 20,
              __component: "linkhub.sell-link",
              Title: "Maryland",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-maryland",
                  },
                },
              },
            },
            {
              id: 21,
              __component: "linkhub.sell-link",
              Title: "Massachusetts",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-massachusetts",
                  },
                },
              },
            },
            {
              id: 22,
              __component: "linkhub.sell-link",
              Title: "Michigan",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-michigan",
                  },
                },
              },
            },
            {
              id: 23,
              __component: "linkhub.sell-link",
              Title: "Minnesota",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-minnesota",
                  },
                },
              },
            },
            {
              id: 24,
              __component: "linkhub.sell-link",
              Title: "Mississippi",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-mississippi",
                  },
                },
              },
            },
            {
              id: 25,
              __component: "linkhub.sell-link",
              Title: "Missouri",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-missouri",
                  },
                },
              },
            },
            {
              id: 26,
              __component: "linkhub.sell-link",
              Title: "Montana",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-montana",
                  },
                },
              },
            },
            {
              id: 27,
              __component: "linkhub.sell-link",
              Title: "Nebraska",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-nebraska",
                  },
                },
              },
            },
            {
              id: 28,
              __component: "linkhub.sell-link",
              Title: "Nevada",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-nevada",
                  },
                },
              },
            },
            {
              id: 29,
              __component: "linkhub.sell-link",
              Title: "New Hampshire",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-new-hampshire",
                  },
                },
              },
            },
            {
              id: 30,
              __component: "linkhub.sell-link",
              Title: "New Jersey",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-new-jersey",
                  },
                },
              },
            },
            {
              id: 31,
              __component: "linkhub.sell-link",
              Title: "New Mexico",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-new-mexico",
                  },
                },
              },
            },
            {
              id: 32,
              __component: "linkhub.sell-link",
              Title: "New York",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-new-york",
                  },
                },
              },
            },
            {
              id: 33,
              __component: "linkhub.sell-link",
              Title: "North Carolina",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-north-carolina",
                  },
                },
              },
            },
            {
              id: 34,
              __component: "linkhub.sell-link",
              Title: "North Dakota",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-north-dakota",
                  },
                },
              },
            },
            {
              id: 35,
              __component: "linkhub.sell-link",
              Title: "Ohio",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-ohio",
                  },
                },
              },
            },
            {
              id: 36,
              __component: "linkhub.sell-link",
              Title: "Oklahoma",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-oklahoma",
                  },
                },
              },
            },
            {
              id: 37,
              __component: "linkhub.sell-link",
              Title: "Oregon",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-oregon",
                  },
                },
              },
            },
            {
              id: 38,
              __component: "linkhub.sell-link",
              Title: "Pennsylvania",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-pennsylvania",
                  },
                },
              },
            },
            {
              id: 39,
              __component: "linkhub.sell-link",
              Title: "Rhode Island",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-rhode-island",
                  },
                },
              },
            },
            {
              id: 40,
              __component: "linkhub.sell-link",
              Title: "South Carolina",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-south-carolina",
                  },
                },
              },
            },
            {
              id: 41,
              __component: "linkhub.sell-link",
              Title: "South Dakota",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-south-dakota",
                  },
                },
              },
            },
            {
              id: 42,
              __component: "linkhub.sell-link",
              Title: "Tennessee",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-tennessee",
                  },
                },
              },
            },
            {
              id: 43,
              __component: "linkhub.sell-link",
              Title: "Texas",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-texas",
                  },
                },
              },
            },
            {
              id: 44,
              __component: "linkhub.sell-link",
              Title: "Utah",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-utah",
                  },
                },
              },
            },
            {
              id: 45,
              __component: "linkhub.sell-link",
              Title: "Vermont",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-vermont",
                  },
                },
              },
            },
            {
              id: 46,
              __component: "linkhub.sell-link",
              Title: "Virginia",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-virginia",
                  },
                },
              },
            },
            {
              id: 47,
              __component: "linkhub.sell-link",
              Title: "Washington",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-washington",
                  },
                },
              },
            },
            {
              id: 48,
              __component: "linkhub.sell-link",
              Title: "West Virginia",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-west-virginia",
                  },
                },
              },
            },
            {
              id: 49,
              __component: "linkhub.sell-link",
              Title: "Wisconsin",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-wisconsin",
                  },
                },
              },
            },
            {
              id: 50,
              __component: "linkhub.sell-link",
              Title: "Wyoming",
              link: {
                data: {
                  attributes: {
                    slug: "/sell/sell-used-car-in-wyoming",
                  },
                },
              },
            },
          ],
        },
      },
    },
  },
];
